import { render, staticRenderFns } from "./ehc-drawer.vue?vue&type=template&id=dc2b7a9c"
import script from "./ehc-drawer.vue?vue&type=script&lang=js"
export * from "./ehc-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports